import { WidgetProps } from '@rjsf/core';
import ThemeColorPicker from '../BaseComponents/ThemeColorPicker';

const ThemeColorPickerWidget = (props: WidgetProps) => {
    const { label, value, options, onChange } = props;
    return (
        <ThemeColorPicker
            label={label}
            value={value}
            colorKey={''}
            uiSchemaOptions={options}
            onChange={onChange}
        />
    );
};

export default ThemeColorPickerWidget;
